module.exports = __webpack_public_path__ + "static/img/2.bd4540c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/eng/2.png
// module id = Lum8
// module chunks = 0